<template>
  <AccountDropdown class="btn-primary" :actions="actions" :activeAction="activeAction" @action-selected="$emit('action-selected', $event)" />
</template>

<script>

export default {
  name: 'account-account-dropdown',
  components: {
    AccountDropdown: () => import('../../../libs/OAuth2/components/AccountDropdown'),
  },
  props: {
    activeAction: {
      type: String,
      validator: function (value) {
        return ['profile', 'change-password', 'logout'].indexOf(value) !== -1;
      },
    },
  },
  data () {
    return {
      actions: [
        { key: 'profile', event: 'profile', label: 'Profilo' },
        { key: 'change-password', event: 'changePassword', label: 'Cambia password' },
        { key: 'logout', event: 'logout', label: 'Logout' },
      ],
    };
  },
};

</script>
